import React from "react";
import Typography from "@material-ui/core/Typography";
const UserReports = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        User Reports
      </Typography>
      <Typography paragraph variant="h5">
        Explore dashboard and various reports of User module
      </Typography>
      <Typography paragraph variant="body1">
        User Reports is one of the features under the User module to display
        various reports regarding the User business process. It is used to
        analyze information, determine conclusions, and offer recommendations to
        solve problems.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the tabs indicating
        the various report types. The various reports under the User module are
        listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>User Dashboard</b>
        <br />
        This is the main dashboard of the User module. There is a lot of
        high-level information shown as a widget to give you the best insight
        regarding what happens in the User business process. This best analytic
        information will help you a lot to make business decisions. Below are
        the available widgets inside this dashboard:
        <ul>
          <li>Users Widget</li>
          <li>Active Users Widget</li>
          <li>Average Time Spent Widget</li>
          <li>Average Sign In Widget</li>
          <li>Users Overview Widget</li>
          <li>Average Users Time Spent Widget</li>
          <li>Top 5 Active Users Widget</li>
          <li>Last Login Overview Widget</li>
          <li>Top 5 Visited Areas Widget</li>
          <li>User Actions Widget</li>
          <li>Sign In Device Widget</li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>User Activity</b>
        <br />
        This report tells you about every user activity in the system and the
        active status of each user with a user time spent analysis during system
        use.
      </Typography>
      <Typography paragraph variant="body1">
        <b>User Session</b>
        <br />
        This report tells you about every user session in the system during
        accessing the features.
      </Typography>
      <Typography paragraph variant="body1">
        <b>User Lock</b>
        <br />
        This report tells you about every user locking mechanism to access the
        platform.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Mail Channel Log</b>
        <br />
        This report tells you about every mail log of every channeling mechanism
        (inbound and outbound).
      </Typography>
    </React.Fragment>
  );
};

export default UserReports;
